<template>
  <div class="users atb-full-height atb-content-bg atb-flex atb-flex-column">
    <common-datagrid ref="usersDatagrid" ID="identityUsersIndex" :columns="columns" :url="$api.sys.users.list" 
    :remoteMethod='requestMethod' :params="search" :filterData="filterData" :filterTotal="filterTotal" :paramsReset="paramsReset" 
    @pagerChange="pagerChange" border="inner" size="medium" :pagination="false" pageSize="10" :isDefSelected="false">
      <template slot="searchForm">
        <el-form class="atb-input" :inline="true"
        v-on:keyup.enter.native.prevent="loadData(1)" @submit.native.prevent>
          <el-form-item label="关键字">
            <el-input v-model="search.Filter" placeholder="用户名/工号" clearable></el-input>
          </el-form-item>
          <el-form-item class="flex-form-item" label="上级">
            <selecter v-model="search.Superior" placeholder="输入工号或姓名查询" :name="search.superiorName"></selecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loadData(1)">查询</el-button>
            <el-button v-if="$auth(that, 'Create')" type="add" @click="edit">新建</el-button>
          </el-form-item>
          <el-form-item v-if="$auth(that, 'Export')">
            <el-button type="export" @click="exportExcel">导出</el-button>
          </el-form-item>
          <el-form-item v-if="$auth(that, 'Import')">
            <el-upload 
              ref="file"
              :http-request="uploadFile"
              :multiple="false"
              :show-file-list='false'
            >
            <el-button type="import">导入</el-button>
           </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="downloadTemplate" @click="downloadTemplate">下载模板</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:option="{ row }">
          <el-link :underline="false" type="primary" v-if="$auth(that, 'Update')" class="link-ele" @click="edit(row)" target="_blank">编辑</el-link>
          <el-link :underline="false" type="primary" class="link-ele" @click="userGroup(row)" target="_blank">分配权限</el-link>
          <el-link :underline="false" type="primary" class="link-ele" @click="resetPwd(row)" target="_blank">重置密码</el-link>
      </template>
      <template v-slot:date="{ row,column }">
        {{(row[column.field] && new Date(row[column.field]) || '') | formatDate('yyyy-MM-dd')}}
      </template>
      <template v-slot:msgConfig="{ row }">
          <el-link :underline="false" type="primary" class="link-ele" @click="msgConfig(row)" target="_blank">消息配置</el-link>
      </template>
      <template v-slot:name="{ row,column }">
        {{ row[column.field]+"("+row['wkNo']+")" }}
      </template>
      <template v-slot:superiorName="{ row,column }">
        {{ row[column.field]? row[column.field]+"("+row['superiorNo']+")": '' }}
      </template>
      <template v-slot:isDismision="{ row,column }">
        {{ row[column.field] == 1 ? '是' : '否' }}
      </template>
      <template v-slot:oec="{ row,column }">
        {{ row[column.field] == 1 ? '是' : '否' }}
      </template>
    <template v-slot:no="{ rowIndex }">
      <div class="vxe-cell">{{(rowIndex+1) + (handledPage.PageIndex-1) * handledPage.PageSize}}</div>
    </template>
    </common-datagrid>
    <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="handledPage.PageIndex"
          :page-size.sync="handledPage.PageSize"
          :total="handledTotal"
          height="100%"
          @page-change="handledPageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
    </div>
    <common-dialog ref="commonDialog" :title="dialogContent.title" width="500px" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="EditRow" @submitSuccess="loadData"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import tableMixin from '@/mixins/table.mixin'
export default {
  mixins: [ tableMixin ],
  components: {
    UserGroup: ()=>import('./UserGroup'),
    MsgConfig: ()=>import('./MsgConfig'),
    Edit: ()=>import('./Edit'),
    selecter: () => import('@/component/global/customerSelect'),
  },
  data() {
    return {
      id: 'id',
      columns: [
        { title: "序号", type: "no", width: "50", align: "center", fixed: "left",slot:'no' },
        { title: "部门名", field: "department", width: "220" },
        { title: "姓名", field: "wkName", width: "120",slot:"name" },
        { title: "上级姓名", field: "superiorName", width: "120",slot:"superiorName" },
        { title: "入职时间", field: "jobDate", width: "100", slot: "date" },
        { title: "离职时间", field: "dimissionTime", width: "100", slot: "date" },
        { title: "是否离职", field: "isDismision", width: "80",slot:"isDismision" },
        { title: "是否OEC", field: "isOEC", width: "80" ,slot:"oec"},
        { title: "不参评原因", field: "noOecReason", width: "160" },
        { title: "消息配置", field: "msgConfig", width: "80", slot: "msgConfig" },
        { title: "操作", field: "option", width: "180", align: "center", fixed: "right", slot: 'option' },
      ],
      datalist:[],
      requestMethod:'get',
      handledPage: {
        PageIndex: 1,
        PageSize: 10
      },
      handledTotal: 0,
      downloadUrl: process.env.VUE_APP_PUBLICPATH + "files/用户信息模板.xlsx",
      that:this,
    }
  },
  created(){
  },
  mounted(){
  },
  methods: {
    userGroup(row){
      this.EditRow = typeof(row) == 'object' ? row || {} : {};
      this.dialogContent = {
        title: '权限组',
        componentName: 'UserGroup'
      }
      this.$refs.commonDialog.show()
    },
    msgConfig(row){
      this.EditRow = typeof(row) == 'object' ? row || {} : {};
      this.dialogContent = {
        title: '消息配置',
        componentName: 'MsgConfig'
      }
      this.$refs.commonDialog.show()
    },
    edit(row){
      if(row.id){
        this.isEdit=true;
      }else{
        this.isEdit=false;
      }
      this.EditRow = typeof(row) == 'object' ? row || {} : {};
      this.dialogContent = {
        title: this.isEdit? '编辑': '新建',
        componentName: 'Edit'
      }
      this.$refs.commonDialog.show()
    },
    loadData(page) {
        this.handledPage.PageIndex = 1;
        this.$refs.usersDatagrid.loadData(page);
    },
    filterData(data){
      return data.rows;
    },
    filterTotal(data){
      this.handledTotal=data.data.total;
      return data.data.total;
    },
    // paramsReset(){
    //   return { Filter: this.search.Filter, SkipCount: (this.handledPage.PageIndex - 1) * this.handledPage.PageSize, MaxResultCount: this.handledPage.PageSize };
    // },
    paramsReset(){
      return { Filter: this.search.Filter,Superior:this.search.Superior, PageIndex: this.handledPage.PageIndex, PageSize: this.handledPage.PageSize };
    },
    handledPageChange({ currentPage }) {
        this.handledPage.PageIndex = currentPage;
        this.$refs.usersDatagrid.loadData(currentPage);
     },
    exportExcel(){
      this.$ajax.get(this.$api.export.user, {Filter: this.search.Filter,Superior: this.search.Superior}, {ignore: true, responseType:'blob'}).then((res)=>{
        if(res.data.type == 'application/json'){
          var reader = new FileReader();
          reader.onload = ()=>{
            var content = reader.result;//内容就在这里
            let json = JSON.parse(content)
            this.$message.error(json.message)
          };
          reader.readAsText(res.data);
        }else{
          const filename='用户信息'
          const filetype='xlsx'
          let data = res.data;
          let url = window.URL.createObjectURL(data)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = filename + '.' + filetype
          a.click()
          window.URL.revokeObjectURL(url)
        }
      }).catch(() => {})
    },
    downloadTemplate(){
      window.location.href= this.downloadUrl;
    },
    uploadFile({file}){
      const params = new FormData();
      params.append('excelfile', file);
      this.$ajax.post(this.$api.sys.users.exportUser,params,{ headers: { 'Content-Type': 'multipart/form-data;' }}).then((res) => {
          if(res.code===0){
             this.$message.success('上传成功');
             this.loadData(1);
          }
      });
    },
    resetPwd(row) {
      this.$confirm('确定要重置密码吗', '重置密码', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(() => {
          this.$ajax.post(this.$api.sys.users.resetPwd, `"${row.userId}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' } }).then(() => {
            this.$message.success("重置成功");
          });
        })
        .catch(() => {
          
        });
    }
  }
}
</script>
<style scoped lang='scss'>
.users{
  .link-ele{
    margin: 0 5px;
  }
  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column:not(.col--ellipsis){
    padding: 12px 0;
  }
  ::v-deep .vxe-table--render-default.vxe-editable.size--medium .vxe-body--column{
    height: 48px;
  }
  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column.col--ellipsis{
    height: 48px;
  }
  .el-button--import{
    background-color: #def6e8;
    border-color: #def6e8;
    color: #0dcc82;
  }
  ::v-deep .el-button--downloadTemplate{
    width: 100px !important;
    background-color: #def6e8;
    border-color: #def6e8;
    color: #0dcc82;
  }
}

</style>
